import React from 'react';
import QRcode from "../qr_view/QR";

function Table({ data }) {
  return (
    <table>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>    
              {item.column1!=undefined&&
                <QRcode text={"lightning:"+item.column1} size_={300}></QRcode>
              }           
            </td>
            <td>                
              {item.column2!=undefined&&
                <QRcode text={"lightning:"+item.column2} size_={300}></QRcode>
              }
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
